module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("‘Vietnam Helicopter “TINS”* From Americal Division Artillery Air Section’")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("Chu Lai, Vietnam 1968 and 1969")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("*TINS, an acronym for war stories that are more or less supposed to be true: ‘This is no shit.’")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/front.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("Driving a Scout Helicopter in Vietnam can be Dangerous to your Health!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eaf095a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_front.vue
// module id = 60
// module chunks = 0